/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class RemoteService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Push Remote Content
     * Creates a new branch if it doesn't exists, uploads the remote content to it, commits the changes and pushes the changes.
     *
     * @returns any OK.
     * @throws ApiError
     */
    pushRemoteContent({ orgId, projectId, formData, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/push', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, formData: formData, mediaType: 'multipart/form-data', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=RemoteService.js.map